/* eslint-disable max-len */
import { INTL_IDS } from '@dmi/shared/redux/SecureMessaging/messages';

export const CHANGE_FORM_FIELD_VALUE = 'app/SecureMessaging/CHANGE_FORM_FIELD_VALUE';

export const CHANGE_SELECTED_MESSAGE_ID = 'app/SecureMessaging/CHANGE_SELECTED_MESSAGE_ID';

export const CHANGE_STEP = 'app/SecureMessaging/CHANGE_STEP';

export const CHOOSE_DOCUMENT = 'app/SecureMessaging/CHOOSE_DOCUMENT';
export const CHOOSE_DOCUMENT_CANCELLATION = 'app/SecureMessaging/CHOOSE_DOCUMENT_CANCELLATION';
export const CHOOSE_DOCUMENT_FAILURE = 'app/SecureMessaging/CHOOSE_DOCUMENT_FAILURE';
export const CHOOSE_DOCUMENT_SUCCESS = 'app/SecureMessaging/CHOOSE_DOCUMENT_SUCCESS';

export const DOWNLOAD_ATTACHMENT = 'app/SecureMessaging/DOWNLOAD_ATTACHMENT';
export const DOWNLOAD_ATTACHMENT_FAILURE = 'app/SecureMessaging/DOWNLOAD_ATTACHMENT_FAILURE';
export const DOWNLOAD_ATTACHMENT_SUCCESS = 'app/SecureMessaging/DOWNLOAD_ATTACHMENT_SUCCESS';

export const FETCH_ATTACHMENT = 'app/SecureMessaging/FETCH_ATTACHMENT';
export const FETCH_ATTACHMENT_CANCELLED = 'app/SecureMessaging/FETCH_ATTACHMENT_CANCELLED';
export const FETCH_ATTACHMENT_FAILURE = 'app/SecureMessaging/FETCH_ATTACHMENT_FAILURE';
export const FETCH_ATTACHMENT_SUCCESS = 'app/SecureMessaging/FETCH_ATTACHMENT_SUCCESS';

export const FETCH_MESSAGES = 'app/SecureMessaging/FETCH_MESSAGES';
export const FETCH_MESSAGES_FAILURE = 'app/SecureMessaging/FETCH_MESSAGES_FAILURE';
export const FETCH_MESSAGES_SUCCESS = 'app/SecureMessaging/FETCH_MESSAGES_SUCCESS';

export const FETCH_MESSAGE_DETAILS = 'app/SecureMessaging/FETCH_MESSAGE_DETAILS';
export const FETCH_MESSAGE_DETAILS_FAILURE = 'app/SecureMessaging/FETCH_MESSAGE_DETAILS_FAILURE';
export const FETCH_MESSAGE_DETAILS_SUCCESS = 'app/SecureMessaging/FETCH_MESSAGE_DETAILS_SUCCESS';

export const POST_MESSAGE = 'app/SecureMessaging/POST_MESSAGE';
export const POST_MESSAGE_FAILURE = 'app/SecureMessaging/POST_MESSAGE_FAILURE';
export const POST_MESSAGE_SUCCESS = 'app/SecureMessaging/POST_MESSAGE_SUCCESS';

export const POST_REPLY = 'app/SecureMessaging/POST_REPLY';
export const POST_REPLY_FAILURE = 'app/SecureMessaging/POST_REPLY_FAILURE';
export const POST_REPLY_SUCCESS = 'app/SecureMessaging/POST_REPLY_SUCCESS';

export const PROCESS_DOCUMENT = 'app/SecureMessaging/PROCESS_DOCUMENT';
export const PROCESS_DOCUMENT_FAILURE = 'app/SecureMessaging/PROCESS_DOCUMENT_FAILURE';
export const PROCESS_DOCUMENT_SUCCESS = 'app/SecureMessaging/PROCESS_DOCUMENT_SUCCESS';

export const REMOVE_ATTACHMENT = 'app/SecureMessaging/REMOVE_ATTACHMENT';

export const RESET_FORM_STATE = 'app/SecureMessaging/RESET_FORM_STATE';
export const RESET_REQUEST_STATUS = 'app/SecureMessaging/RESET_REQUEST_STATUS';
export const RESET_STEP = 'app/SecureMessaging/RESET_STEP';
export const RESET_SECURE_MESSAGE_STATE = 'app/SecureMessaging/RESET_SECURE_MESSAGE_STATE';

export const SET_ATTACHMENT_FILE = 'app/SecureMessaging/SET_ATTACHMENT_FILE';
export const SET_BANNER_ERROR = 'app/SecureMessaging/SET_BANNER_ERROR';

export const TOGGLE_ATTACHMENT_DRAWER = 'app/SecureMessaging/TOGGLE_ATTACHMENT_DRAWER';

export const UPDATE_ATTACHMENTS = 'app/SecureMessaging/UPDATE_ATTACHMENTS';

export const UPLOAD_ATTACHMENTS_FAILURE = 'app/SecureMessaging/UPLOAD_ATTACHMENTS_FAILURE';

// Screen messages

export const INFO_COPY_DICT = {
  confirmation: [
    {
      text: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
      variant: 'pending',
    },
  ],
};

export const POST_MESSAGE_SUCCESS_MESSAGE = 'Success! We received your message';
export const SUCCESS_CONFIRMATION_TEXT = 'Your message has been submitted and has been referred to the appropriate area for review.';

export const CLOSED_MESSAGE_MESSAGE = 'Please send a new message if you have questions related to this conversation.';

export const FETCH_MESSAGE_DETAILS_FAILURE_MESSAGE = 'An error has occurred while trying to retrieve your message details.';
export const FETCH_MESSAGES_FAILURE_MESSAGE = 'An error has occurred while trying to retrieve your messages.';

export const POST_MESSAGE_FAILURE_ERROR_MESSAGE = 'We are unable to send your message at this time';

// Attachment constants

export const ATTACHMENT_BLOCKED_MESSAGE = 'You will need to enable pop-ups in your browser for this site in order to view this content.';
export const ATTACHMENT_DOCUMENT_CATEGORY = 'secureMessaging';
export const DOWNLOAD_ERROR_MESSAGE = 'Unable to download file. Please try again later.';
export const FETCH_ERROR_MESSAGE = DOWNLOAD_ERROR_MESSAGE;

// Secure message constants

export const CONFIRMATION_DICT = {
  desktopPath: '/securemessaging',
  error: {
    body: 'An error has occurred while trying to send your message. For assistance, please call customer service at ',
    defaultCustomerServicePhoneNumber: '1-855-857-0644',
    header: 'We are unable to send your message at this time',
  },
  linkLabel: 'Return to Secure Messaging',
  mobilePath: 'SecureMessaging',
  success: {
    body: 'Your message has been submitted and has been referred to the appropriate area for review.',
    footerText: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
    header: 'Success! We received your message',
  },
};

export const ERROR_CONFIRMATION_TEXT = 'An error has occured while trying to send your message. For assistance, please call customer service at {{customerServicePhoneNumber}}.';

export const DROPDOWN_TOPICS = {
  subTopic: [
    'Hardship Assistance',
    'Disaster Assistance',
    'Select Item',
    'Select Item',
    'Select Item',
    'Select Item',
  ],
  /* eslint-disable quote-props */
  topic: {
    'ARM Loan': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_ARMLOAN,
    'Assumption': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_ASSUMPTION,
    'Auto Drafting': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_AUTODRAFTING,
    'Bankruptcy/Foreclosure': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_BANKRUPTCYFORCLOSURE,
    'Bi-Saver Program': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_BISAVERPROGRAM,
    'Coupon Request': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_COUPONREQUEST,
    'COVID19 Hardship Request': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_COVID19HARDSHIPREQUEST,
    'Credit Reporting': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_CREDITREPORTING,
    'Delinquent Payment': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_DELINQUENTPAYMENT,
    'Escrow Analysis': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_ESCROWANALYSIS,
    'Hazard Insurance': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_HAZARDINSURANCE,
    'Late Charge(s)': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_LATECHARGES,
    'Loss Draft': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_LOSSDRAFT,
    'Lost/Misapplied Payment': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_LOSTMISAPPLIEDPAYMENT,
    'Optional Insurance': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_OPTIONALINSURANCE,
    'Other': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_OTHER,
    'Payoff Release Doc': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PAYOFFRELEASEDOC,
    'Payoff Statement': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PAYOFFSTATEMENT,
    'PMI Cancellation': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PMICANCELLATION,
    'PMI Insurance': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PMIINSURANCE,
    'Promise to Pay': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PROMISETOPAY,
    'Refinance': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_REFINANCE,
    'Regular Payment': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_REGULARPAYMENT,
    'Statement/Coupon': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_STATEMENTCOUPON,
    'Taxes': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_TAXES,
    'Update Personal Information': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_UPDATEPERSONALINFORMATION,
    'Year-End 1098': INTL_IDS.SECURE_MESSAGING_DROPDOWN_OPTION_YEAREND1098,
  },
  /* eslint-enable quote-props */
};

export const MOBILE_DOC_UPLOAD_DICT = {
  description: 'Make sure your document is readable, complete, and includes any signatures if applicable.\n\nIf you are submitting an insurance card, please upload an image of the front and back of the card.',
  headerLabel: 'Add Attachment',
  secondaryHeader: 'Add a document to your message',
};

export const MOBILE_DOC_REVIEW_DICT = {
  description: 'The document(s) below will be attached and sent with your message. Maximum of 5 files allowed.',
  headerLabel: 'Review Document Upload',
  secondaryHeader: 'Review your document',
};

// Inbox constants
export const SECURE_MESSAGING_INBOX_BUTTON_LABEL = 'Send New Message';
export const SECURE_MESSAGING_INBOX_HEADING_LABEL = 'Secure Messaging';

export const SECURE_MESSAGING_NEW_MESSAGE_PATH_DICT = {
  desktopPath: '/securemessaging/newmessage',
  mobilePath: 'NewMessage',
};
